import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

export enum CommunityIconVariant {
  DEFAULT = 'default',
}

interface ICommunityIconProps extends IConDefaultType {
  variant?: CommunityIconVariant;
}

function CommunityIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = CommunityIconVariant.DEFAULT,
}: ICommunityIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === CommunityIconVariant.DEFAULT && (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="icon/community">
            <path
              id="icon/community_2"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.6737 1.6585C14.6737 1.20286 15.0431 0.833496 15.4987 0.833496C15.9543 0.833496 16.3237 1.20286 16.3237 1.6585V3.67516H18.3404C18.796 3.67516 19.1654 4.04453 19.1654 4.50016C19.1654 4.9558 18.796 5.32516 18.3404 5.32516H16.3237V7.34183C16.3237 7.79746 15.9543 8.16683 15.4987 8.16683C15.0431 8.16683 14.6737 7.79746 14.6737 7.34183V5.32516H12.657C12.2014 5.32516 11.832 4.9558 11.832 4.50016C11.832 4.04453 12.2014 3.67516 12.657 3.67516H14.6737V1.6585ZM10.9154 0.834498H8.16536C4.11528 0.834498 0.832031 4.11774 0.832031 8.16783V10.0012C0.832031 12.2367 1.83233 14.2386 3.40975 15.5836L2.95175 18.0838L2.93853 18.19C2.90833 18.648 3.22554 19.066 3.68792 19.1508L3.80716 19.1647C3.9268 19.1707 4.04687 19.1533 4.16046 19.1129L9.16178 17.3345H11.832C15.8821 17.3345 19.1654 14.0513 19.1654 10.0012V9.06607H19.1645C19.1651 9.05379 19.1654 9.04143 19.1654 9.02901C19.1654 8.59869 18.8165 8.24984 18.3862 8.24984C17.9559 8.24984 17.607 8.59869 17.607 9.02901C17.607 9.04143 17.6073 9.05379 17.6079 9.06607H17.607V10.001L17.6032 10.2127C17.4918 13.3041 14.9506 15.776 11.832 15.776H8.89297L4.68295 17.2729L5.10445 14.9806L4.42086 14.3977L4.23279 14.2302C3.0672 13.1465 2.39036 11.6303 2.39036 10.001V8.16766L2.39417 7.95595C2.50558 4.86458 5.0468 2.39266 8.16536 2.39266H10.9154V2.39134C10.9305 2.39222 10.9458 2.39266 10.9612 2.39266C11.3915 2.39266 11.7404 2.04382 11.7404 1.6135C11.7404 1.18317 11.3915 0.834329 10.9612 0.834329C10.9458 0.834329 10.9305 0.834775 10.9154 0.835655V0.834498ZM5.83203 12.4993C5.37179 12.4993 4.9987 12.1262 4.9987 11.666C4.9987 11.2057 5.37179 10.8327 5.83203 10.8327H12.4987C12.9589 10.8327 13.332 11.2057 13.332 11.666C13.332 12.1262 12.9589 12.4993 12.4987 12.4993H5.83203ZM5.83203 8.74932C5.37179 8.74932 4.9987 8.37622 4.9987 7.91598C4.9987 7.45575 5.37179 7.08265 5.83203 7.08265H9.16536C9.6256 7.08265 9.9987 7.45575 9.9987 7.91598C9.9987 8.37622 9.6256 8.74932 9.16536 8.74932H5.83203Z"
              fill={color ?? EColorMap.gray_0}
            />
          </g>
        </svg>
      )}
    </i>
  );
}

export default CommunityIcon;
